import { defaultStateType } from "../Store/defaultStatus";

export function reducer(state: any, action: any) {
  console.log('this is productReducer!')

  switch (action.type) {
    case "PRODUCT":
      return { ...state, ...action.playload };
    default:
      return state;
  }
}

export function productAction(object: defaultStateType) {
  return { type: "PRODUCT", playload: object };
}
